import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";


const TopSection = () => {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <div className="w-full bg-custom-bg text-black flex justify-between items-center px-4 py-2 text-sm relative">
      {/* Left Text */}
      <div className="flex items-center space-x-2">
        <span className="font-medium">महाराष्ट्र शासन</span>
        <span>|</span>
        <span className="font-medium">Government of Maharashtra</span>
      </div>

    </div>
  );
};

export default TopSection;
